export default __webpack_public_path__ + "static/extra-money-tab-457fc3ec96ec09fc3ccf40b71e8b403a.png";